var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","sm":"12"}},[_c('card-navigation')],1),_c('v-col',{attrs:{"cols":"12","md":"6","sm":"12"}},[_c('custom-timeline-card')],1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }